// extracted by mini-css-extract-plugin
export default {"loadingScreen":"LoadingScreen_loadingScreen__3iTIF","loadingContent":"LoadingScreen_loadingContent__B3tre","loadingText":"LoadingScreen_loadingText__2fOdt"};